import * as I18n from 'i18n-js';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';

class AffirmBanner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({ expanded: !this.state.expanded });
  }

  renderShowDetails() {
    if (!this.props.months.length) { return <br />; }

    return (
      <a
        className="affirm-banner__toggle"
        onClick={this.toggle}
      >
        {I18n.t('discovery.affirmBanner.learnMore')}
      </a>
    );
  }

  render() {
    const classes = classNames(
      'affirm-banner',
      { 'affirm-banner--open': this.state.expanded },
    );

    return (
      <aside className={classes}>
        <div className="affirm-banner__inner">
          <h1 className="affirm-banner__title">
            {I18n.t('discovery.affirmBanner.title')}
          </h1>
          <p className="affirm-banner__description">
            {I18n.t('discovery.affirmBanner.description')}
            <br />
            {this.renderShowDetails()}
          </p>
          <p className="affirm-banner__fineprint">
            {I18n.t(
              'discovery.affirmBanner.fineprint',
              {
                months1: this.props.months[0],
                months2: this.props.months[1],
                months3: this.props.months[2],
              },
            )
            }
          </p>
        </div>
      </aside>
    );
  }
}

AffirmBanner.propTypes = {
  months: PropTypes.array,
};

AffirmBanner.defaultProps = {
  months: [],
};

export default AffirmBanner;



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/discovery/affirm_banner.jsx